import React from 'react'
import classNames from 'classnames'

type Props = {
    label: string
    value: number | string
    classes?: string
}

const DataViewBox: React.FC<Props> = ({ label, value, classes }) => {
    return (
        <div className={classNames('dataViewBox', classes)}>
            <div className="label">{label}</div>
            <div className="value">{value}</div>
        </div>
    )
}

export default DataViewBox
